import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from '../interfaces/base-response';
import { withToast } from '@rieaya-core';
import { AThirdPartyIntegrationService } from '@rieaya-laundry-api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiAThirdPartyIntegrationService = inject(
    AThirdPartyIntegrationService
  );

  login(): Observable<BaseResponse<unknown>> {
    return this.apiAThirdPartyIntegrationService.apiAThirdPartyIntegrationRopLoginAndLoginUserPost(
      undefined,
      'body',
      false,
      {
        context: withToast(),
      }
    );
  }

  logout(): Observable<BaseResponse<unknown>> {
    return this.apiAThirdPartyIntegrationService.apiAThirdPartyIntegrationLogoutGet(
      undefined,
      'body',
      false,
      {
        context: withToast(),
      }
    );
  }
}
